import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  template: `
    <h2 mat-dialog-title>{{ data.title || 'Confirm' }}</h2>
    <mat-dialog-content>
      <p>{{ data.message || 'Are you sure you want to delete this item?' }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()" [disabled]="isDeleting">Cancel</button>
      <button mat-raised-button color="warn" (click)="onConfirm()" [disabled]="isDeleting" style="position:relative; min-width:90px;">
        <ng-container *ngIf="!isDeleting; else deletingTpl">Delete</ng-container>
        <ng-template #deletingTpl>
          <span style="display:flex; justify-content:center; align-items:center; width:100%; height:100%;">
            <mat-spinner diameter="24" color="accent"></mat-spinner>
          </span>
        </ng-template>
      </button>
    </mat-dialog-actions>
  `
})
export class ConfirmDialogComponent {
  isDeleting = false;
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onConfirm(): void {
    this.isDeleting = true;
    setTimeout(() => {
      this.dialogRef.close(true);
      this.isDeleting = false;
    }, 500); // Simulate async delete, replace with real logic if needed
  }

  onCancel(): void {
    if (!this.isDeleting) {
      this.dialogRef.close(false);
    }
  }
}
